export const routeNames = {
  AUTH_EXPIRED: 'AUTH_EXPIRED',
  NOT_FOUND: 'NOT_FOUND',
  PAGE_VIEW: 'PAGE_VIEW',
  PREVIEW: 'PREVIEW',
  PREVIEW_V2: 'PREVIEW_V2',
  SERVER_ERROR: 'SERVER_ERROR',
};
